import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import * as Plotly from 'plotly.js';
declare global {
  interface Window {
    Plotly: typeof Plotly;
  }
}
@Component({
  selector: 'app-plotly-line',
  templateUrl: './plotly-line.component.html',
  styleUrls: ['./plotly-line.component.css']
})
export class PlotlyLineComponent implements OnInit, OnChanges {
  @ViewChild("line", { static: true }) private _line: ElementRef<HTMLElement>;
  @Input() lineData: any;
  private _shapes: any[] = [];
  constructor() { }

  ngOnInit(): void { }

  ngOnChanges() {
    if (this.lineData.length)
      this._plotGraph();
  }

  private _plotGraph() {
    this._shapes = [];
    if (this.lineData?.find((item: any) => item.attributeThresholdMarker)?.attributeThresholdMarker) {
      let attributeThresholdMarker = this.lineData?.find((item: any) => item.attributeThresholdMarker)?.attributeThresholdMarker;
      if ((attributeThresholdMarker?.upper || attributeThresholdMarker?.upper === 0) && (attributeThresholdMarker?.showAttributeUpperLine || attributeThresholdMarker?.showWindowUpperLine)) {
        this._shapes.push({
          type: 'line',
          xref: 'paper',
          x0: 0,
          y0: attributeThresholdMarker?.upper,
          x1: 1,
          y1: attributeThresholdMarker?.upper,
          line: {
            color: attributeThresholdMarker?.color ? attributeThresholdMarker?.color : 'rgb(255, 0, 0)',
            width: 2,
            dash: 'dot'
          }
        })
      }
      if ((attributeThresholdMarker?.lower || attributeThresholdMarker?.lower === 0) && (attributeThresholdMarker?.showAttributeLowerLine || attributeThresholdMarker?.showWindowLowerLine)) {
        this._shapes.push({
          type: 'line',
          xref: 'paper',
          x0: 0,
          y0: attributeThresholdMarker?.lower,
          x1: 1,
          y1: attributeThresholdMarker?.lower,
          line: {
            color: attributeThresholdMarker?.color ? attributeThresholdMarker?.color : 'rgb(255, 0, 0)',
            width: 2,
            dash: 'dot'
          }
        })
      }
      // this.shapes = [
      //   {
      //     type: 'line',
      //     xref: 'paper',
      //     x0: 0,
      //     y0: ((attributeThresholdMarker?.upper || attributeThresholdMarker?.upper === 0) && (attributeThresholdMarker?.showAttributeUpperLine || attributeThresholdMarker?.showWindowUpperLine)) ? attributeThresholdMarker?.upper : undefined,
      //     x1: 1,
      //     y1: ((attributeThresholdMarker?.upper || attributeThresholdMarker?.upper === 0) && (attributeThresholdMarker?.showAttributeUpperLine || attributeThresholdMarker?.showWindowUpperLine)) ? attributeThresholdMarker?.upper : undefined,
      //     line: {
      //       color: attributeThresholdMarker?.color ? attributeThresholdMarker?.color : 'rgb(255, 0, 0)',
      //       width: 2,
      //       dash: 'dot'
      //     }
      //   },
      //   {
      //     type: 'line',
      //     xref: 'paper',
      //     x0: 0,
      //     y0: ((attributeThresholdMarker?.lower || attributeThresholdMarker?.lower === 0) && (attributeThresholdMarker?.showAttributeLowerLine || attributeThresholdMarker?.showWindowLowerLine)) ? attributeThresholdMarker?.lower : undefined,
      //     x1: 1,
      //     y1: ((attributeThresholdMarker?.lower || attributeThresholdMarker?.lower === 0) && (attributeThresholdMarker?.showAttributeLowerLine || attributeThresholdMarker?.showWindowLowerLine)) ? attributeThresholdMarker?.lower : undefined,
      //     line: {
      //       color: attributeThresholdMarker?.color ? attributeThresholdMarker?.color : 'rgb(255, 0, 0)',
      //       width: 2,
      //       dash: 'dot'
      //     }
      //   }
      // ]
    }
    if (this.lineData?.find((item: any) => item.deviceThresholdMarker)?.deviceThresholdMarker) {
      let deviceThresholdMarker = this.lineData?.find((item: any) => item.deviceThresholdMarker)?.deviceThresholdMarker;
      if ((deviceThresholdMarker?.upper || deviceThresholdMarker?.upper === 0) && (deviceThresholdMarker?.deviceAttributeUpperLine || deviceThresholdMarker?.deviceWindowUpperLine)) {
        this._shapes.push(
          {
            type: 'line',
            xref: 'paper',
            x0: 0,
            y0: deviceThresholdMarker?.upper,
            x1: 1,
            y1: deviceThresholdMarker?.upper,
            line: {
              color: deviceThresholdMarker?.color ? deviceThresholdMarker?.color : 'rgb(255, 0, 0)',
              width: 2,
              dash: 'dot'
            }
          })
      }
      if ((deviceThresholdMarker?.lower || deviceThresholdMarker?.lower === 0) && (deviceThresholdMarker?.deviceAttributeLowerLine || deviceThresholdMarker?.deviceWindowLowerLine)) {
        this._shapes.push({
          type: 'line',
          xref: 'paper',
          x0: 0,
          y0: deviceThresholdMarker?.lower,
          x1: 1,
          y1: deviceThresholdMarker?.lower,
          line: {
            color: deviceThresholdMarker?.color ? deviceThresholdMarker?.color : 'rgb(255, 0, 0)',
            width: 2,
            dash: 'dot'
          }
        }
        )
      }
      // this.shapes.push(
      //   {
      //     type: 'line',
      //     xref: 'paper',
      //     x0: 0,
      //     y0: (deviceThresholdMarker?.upper || deviceThresholdMarker?.upper === 0) ? deviceThresholdMarker?.upper : null,
      //     x1: 1,
      //     y1: (deviceThresholdMarker?.upper || deviceThresholdMarker?.upper === 0) ? deviceThresholdMarker?.upper : null,
      //     line: {
      //       color: deviceThresholdMarker?.color ? deviceThresholdMarker?.color : 'rgb(255, 0, 0)',
      //       width: 2,
      //       dash: 'dot'
      //     }
      //   },
      //   {
      //     type: 'line',
      //     xref: 'paper',
      //     x0: 0,
      //     y0: (deviceThresholdMarker?.lower || deviceThresholdMarker?.lower === 0) ? deviceThresholdMarker?.lower : null,
      //     x1: 1,
      //     y1: (deviceThresholdMarker?.lower || deviceThresholdMarker?.lower === 0) ? deviceThresholdMarker?.lower : null,
      //     line: {
      //       color: deviceThresholdMarker?.color ? deviceThresholdMarker?.color : 'rgb(255, 0, 0)',
      //       width: 2,
      //       dash: 'dot'
      //     }
      //   })
    }
    let annotations;
    if (this.lineData && this.lineData.length) {
      this.lineData.forEach(e => {
        e.annotations ? annotations = [...this.lineData[0].annotations, ...e.annotations] : this.lineData[0].annotations;
      })
    }
    window.Plotly.newPlot(
      this._line.nativeElement, //viewchild element
      this.lineData, //data provided
      {
        // height: this.lineData[0].height ? this.lineData[0].height : 350,
        // width: this.lineData[0].width ? this.lineData[0].width : 370,
        margin: this.lineData[0].margin,
        title: this.lineData[0].title, //Title of the graph
        hovermode: "closest",
        showlegend: this.lineData[0].legend ? this.lineData[0].legend : false,
        // legend: {
        //   x: 0.03,
        //   y: 1,
        //   traceorder: 'normal',
        //   font: {
        //     family: 'sans-serif',
        //     size: 12,
        //     color: '#000'
        //   },
        //   bordercolor: '#FFFFFF',
        //   borderwidth: 2
        // },
        legend: { "orientation": "h" },
        hoverlabel: { bgcolor: '#EDEBEB', align: 'left', font: { family: 'Open Sans', color: '#585A5A', size: 13 }, bordercolor: '#EDEBEB' },
        yaxis: {
          fixedrange: false,
          tickangle: -45,
          showgrid: this.lineData[0].showgrid
        },
        xaxis: {
          fixedrange: false,
          showgrid: this.lineData[0].showgrid
        },
        shapes: this._shapes.length ? this._shapes : null,
        paper_bgcolor: this.lineData[0].barColor ? this.lineData[0].barColor : "#f6f6f6",
        plot_bgcolor: this.lineData[0].barColor ? this.lineData[0].barColor : "#f6f6f6",
        annotations: annotations,
        dragmode: false
      },
      { //this is where the configuration is defined
        responsive: true,
        displaylogo: false,
        scrollZoom: true,
        displayModeBar: false,
      });
    (document.getElementById('line') as any).on('plotly_legendclick', function (event) {
      setTimeout(() => {
        let annotationHideFlag = event?.data?.[0]?.visible === 'legendonly';
        let newAnnotations = (document.getElementById('line') as any).layout.annotations.map((item: any) => {
          return {
            ...item,
            visible: !annotationHideFlag
          };
        });
        window.Plotly.relayout(document.getElementById('line'), {
          annotations: newAnnotations
        });
      }, 400);
    });
    window.dispatchEvent(new Event('resize'));
  }
}
